<template>
    <!-- 船司账号 -->
    <div  class="person">
        <div class="tit">
            船司账号
        </div>
        <div class="tixing">
            <i class="el-icon-info"></i>
            订舱时使用船司账号订舱，请确保订舱账号正确无误
        </div>

        <div class="yi">
            <el-select class="xila" clearable  filterable v-model="form.carrier_code"  placeholder="船公司">
                <el-option
                v-for="item in shippingList"
                :key="item.id"
                :label="item.name_cn+'-'+item.name_en"
                :value="item.code"
                >
                </el-option>
            </el-select>
            <el-select class="xila" clearable  filterable v-model="form.is_disable" placeholder="是否禁用">
                <el-option label="全部" value=""></el-option>
                <el-option label="否" value="0"></el-option>
                <el-option label="是" value="1"></el-option>
            </el-select>
            <el-input v-model="form.account" clearable  filterable  placeholder="船司账号"></el-input>
            <div class="btns">
                <el-button class="chongzhi" @click="chongzhi">重置</el-button>
                <el-button class="shaixuan" @click="getList">筛选</el-button>
            </div>
        </div>
        <div class="btnss">
            <el-button @click="addList" icon="el-icon-plus">添加账号</el-button>
            <!-- <el-button class="update">导入账号</el-button> -->
            
            <el-upload
                :on-success="successUpload"
                :on-error="errorUpload"
                class="upload-demo"
                action="https://serve.dhcang.com/api/userShippingCompanyAccount/import"
                multiple
                :show-file-list="false"
                :headers="headers"
                >
                <el-button  class="update" slot="trigger" size="small" type="primary">导入账号</el-button>
                </el-upload>

            <el-button class="up" @click="xiazai">下载账号导入模版</el-button>

        </div>

        <!-- 表格 -->
        <el-table
            v-loading="loading"
            :data="tableList"
            style="width: 100%"
            :header-cell-style="{ background: '#f9f9f9' }"
        >
            <el-table-column prop="carrier_code" label="船公司"> </el-table-column>
            <el-table-column prop="enterprise_name" label="公司名称"> </el-table-column>
            <el-table-column prop="account" label="船司账号"> </el-table-column>
            <el-table-column label="设为默认账号">
                <template slot-scope="scope">
                  <el-switch
                    v-model="scope.row.is_default"
                    :active-value="0"
                    :inactive-value="1"
                    @change="changeDefault(scope.row)"
                    active-color="#0073F5"
                  >
                  </el-switch>
                </template>
            </el-table-column>
            <el-table-column label="账号状态">
                <template slot-scope="scope">
                  <el-switch
                    v-model="scope.row.is_disable"
                    :active-value="0"
                    :inactive-value="1"
                    @change="changeStatus(scope.row)"
                    active-color="#0073F5"
                  >
                  </el-switch>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button class="bianji" type="text" @click="editList(scope.row)">编辑</el-button>
                    <span class="gang">/</span>
                    <el-button type="text" class="del" @click="delList(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="form.page_no"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>

        <!-- 添加账号对话框 -->
        <el-dialog :title="title" :visible.sync="dialogFormVisible">
            <el-form :model="dialogForm">
                <el-form-item label="企业名称">
                    <el-input v-model="dialogForm.enterprise_name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="船公司">
                    <el-select v-model="dialogForm.carrier_code" clearable  filterable placeholder="请选择">
                        <el-option
                        v-for="item in shippingList"
                        :key="item.id"
                        :label="item.name_cn+'-'+item.name_en"
                        :value="item.code"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="船司账号">
                    <el-input v-model="dialogForm.account" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="登录密码">
                    <el-input v-model="dialogForm.password" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitDialogForm">确 定</el-button>
            </div>
            </el-dialog>
    </div>
</template>
    
<script>
import { 
    baseShippingCompanyValidList,
    shippingAccountList,shippingAccountAdd,shippingAccountEdit,
    shippingAccountDisable,shippingAccountDefault,
    shippingAccountDelete,
    shippingAccountDownload,
    // shippingAccountImport,
} from "@/api/api";
export default {
    components:{
        
    },
    data() {
        return {
            form:{
                page_no:1,
                page_size:10,
                // carrier_`code:'',
                // enterprise_name:'',
                // account:'',
                // is_disable`:'',
            },
            dialogForm:{
                carrier_code:'',
                enterprise_name:'',
                account:'',
                password:'',
            },
            dialogFormVisible:false,
            headers:{
                'token':localStorage.getItem('token')
            },
            total:0,
            tableList:[],
            title:'添加船司账号',
            loading:false,
            shippingList:[],
        }
    },
    methods: {
        handleSizeChange(val) {
            this.form.page_size=val
            this.getList()
        },
        handleCurrentChange(val) {
            this.form.page_no=val
            this.getList()
        },
        async getList(){
            this.loading = true
            try {
                const res = await shippingAccountList(this.form,this.headers)
                this.tableList=res.data.lists
                this.total=res.data.count
                this.loading = false
            } catch (error) {
                console.log(error,'失败');
            }
        },
        async addList(){
            this.dialogFormVisible = true
            this.title='添加船司账号'
            this.dialogForm = {
                carrier_code:'',
                enterprise_name:'',
                account:'',
                password:'',
            }
        },
        async editList(e){
            this.dialogFormVisible = true
            this.title='修改船司账号'
            this.dialogForm = {
                id:e.id,
                carrier_code:e.carrier_code,
                enterprise_name:e.enterprise_name,
                account:e.account,
                password:e.password,
            }
        },
        delList(e){
            this.$confirm("此操作将删除此账号, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
            .then(async () => {
                try {
                    const res = await shippingAccountDelete({
                        id: e.id
                    },this.headers);
                    if (res.code == 1) {
                        this.$message({
                            type: "success",
                            message: "删除成功",
                        });
                        this.getList()
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg,
                        });
                    }
                } catch (error) {
                    console.log(error, "失败");
                }
            })
            .catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消删除",
                });
            });
        },
        async submitDialogForm(){
            try {
                let api = shippingAccountAdd
                let mssg = '添加成功'
                if(this.title=='修改船司账号'){
                    api = shippingAccountEdit
                    mssg = '修改成功'
                }
                const res = await api(this.dialogForm,this.headers)
                if(res.code ==  1 ){
                    this.$message({
                        type:'success',
                        message:mssg
                    })
                    this.dialogFormVisible = false
                    this.getList()
                }else{
                    this.$message({
                        type:'error',
                        message:res.msg
                    })
                }
                
            } catch (error) {
                console.log(error,'失败');
            }
        },
        // 船公司
        async getShippingList() {
            const res = await baseShippingCompanyValidList();
            if (res.code==1) {
                this.shippingList=res.data
            }
        },
        // 修改账号是否禁用状态
        async changeStatus(e) {
            try {
                const res = await shippingAccountDisable({
                    id: e.id,
                },this.headers);
                if (res.code == 1) {
                    this.$message({
                        type: "success",
                        message: "状态修改成功",
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            } catch (error) {
                console.log(error, "失败");
            }
        },
        // 是否是默认账号
        async changeDefault(e) {
            try {
                const res = await shippingAccountDefault({
                    id: e.id,
                },this.headers);
                if (res.code == 1) {
                    this.$message({
                        type: "success",
                        message: "默认账号修改成功",
                    });
                    this.getList()
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            } catch (error) {
                console.log(error, "失败");
            }
        },
        // 重置
        chongzhi(){
            this.form={
                page_no:1,
                page_size:10,
            }
            this.getList()
        },
        // 下载账号导入模版
        async xiazai(){
            // shippingAccountDownload
            try {
                const res = await shippingAccountDownload(this.headers)
                if(res.code==1){
                    this.$message({
                        type:'success',
                        message:'下载成功'
                    })
                    const link = document.createElement('a');
                    link.href = res.data.file_path;
                    link.setAttribute('download', '');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }else{
                    this.$message({
                        type:'error',
                        message:res.msg
                    })
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
        // 导入
        async successUpload(){
            this.$message({
                type:'success',
                message:'导入成功'
            })

            this.getList()
        },
        errorUpload(err){
            this.$message({
                type:'success',
                message:err
            })
        },
    },
    mounted(){
        this.getList()
        this.getShippingList()
    }
}
</script>
    
<style style lang="scss" scoped>
.person{
    padding: 32px 32px 24px 32px ;
    box-sizing: border-box;

    height: 100%;
    .tit{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        font-style: normal;
        text-transform: none;
    }

    .tixing{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        font-style: normal;
        text-transform: none;
        margin-top: 8px;
        margin-bottom: 24px;
    }

    .yi{
        display: flex;
        justify-content: space-between;

        margin-top: 4px;

        .btns{
            .chongzhi{
                width: 100px;
                height: 40px;
                background: #F9F9F9;
                border-radius: 8px 8px 8px 8px;
                border: 0;

                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 16px;
                color: #999999;
                font-style: normal;
                text-transform: none;
            }

            .shaixuan{
                width: 100px;
                height: 40px;
                background: #0073F5;
                border-radius: 8px 8px 8px 8px;
                border: 0;

                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 16px;
                color: #fff;
                font-style: normal;
                text-transform: none;
            }
        }

        :deep(.el-input){
            width: 360px;
            height: 40px;
            margin-bottom: 16px;

            input{
                width: 352px;
                height: 40px;
                background: #F9F9F9;
                border-radius: 8px 8px 8px 8px;

                border: 0;
            }
        }

        .xila{
            :deep(.el-input){
                margin-bottom: 16px;
                width: 164px;
                input{
                    width: 164px;
                }
            }
        }
    }

    

    .table{
        width: 100%;
        border-spacing: 0;

        border-bottom: solid 1px #eee;

        margin-top: 4px;

        .theader{
            height: 48px;
            background: #F9F9F9;

            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #999999;
            font-style: normal;
            text-transform: none;
        
        }
        .first{
            padding-left: 24px;
            // width: 320px;
        }
        .tbody{
            height: 68px;
            background: #fff;

            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #333333;
            font-style: normal;
            text-transform: none;
        }
    }

    .el-pagination{
        text-align: right;
        margin-top: 80px;
    }

    .btnss{
        margin-top: 20px;
        margin-bottom: 20px;

        .el-button{
            height: 40px;
            background: #EDF6FF;
            border-radius: 8px 8px 8px 8px;

            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #0073F5;
            font-style: normal;
            text-transform: none;

            border: 0;
        }

        .upload-demo{
            display: inline-block;
            margin-left: 24px;
        }

        .update{
            width: 98px;
            border: 1px solid #0073F5;
            background: #fff;
        }

        .up{
            background: #fff;
        }
    }

    :deep(.el-dialog){
        width: 480px ;
        .el-form-item__label{
            width: 78px;
            font-size: 14px;
            color: #999999;
            text-align: left;
            margin-left: 26px;
        }

        .el-input{
            margin-bottom: 16px;
            width: 320px;
            input{
                height: 40px;
                background: #F9F9F9;
                border-radius: 8px 8px 8px 8px;

                border: 0;
            }
        }
    }
}

.gang {
    color: #999999;
    font-size: 14px;
}

.bianji {
    color: #0073f5;
    font-size: 14px;
}
.del {
    font-size: 14px;
    color: #fe3300;
}
</style>